module.exports = __webpack_public_path__ + "static/media/back10.87f39490.jpg";